export default __webpack_public_path__ + "static/media/07__o_preview_3.78e06cae.jpg";